import {format, parseJSON} from 'date-fns';

export const getFormatDate = (date: Date | string): string => format(parseJSON(date), 'd MMM Y');

export const getFormatDateForInvoices = (date: Date | string): string => format(parseJSON(date), 'MMM d, Y');

export const isValidDate = (date?: Date | null) => {
  return date instanceof Date && date.toString() !== 'Invalid Date';
};
